export class TypeCheckUtils {
  static isPrimitive(obj: any): boolean {
    return obj !== Object(obj);
  }
}
